exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content[data-v-10a88b3e]{width:90%;margin:50px auto 0}.stepOne-form[data-v-10a88b3e]{width:100%;margin:50px auto 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-10a88b3e&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/mobile/stepOne.vue
// module id = 155
// module chunks = 0